import React, { useEffect } from "react";
import "./Dashboard.css";
import Sidebar from "../../components/Sidebar"
import DashboardHeader from "./DashboardHeader.js";
import { useSelector, useDispatch } from "react-redux";
import { FaFile, FaUserAlt, FaUsers } from "react-icons/fa";
import { clearError, getDashboard} from "../../actions/fileAction";
import MetaData from "../../components/MetaData";
import { toast } from "react-toastify";
import Loading from "../../components/Loading/loading";
import { RiGlobalFill } from "react-icons/ri";


const Dashboard = ({setUnderLine,underLine}) => {
  setUnderLine('dashboard')
  const dispatch = useDispatch();
  const { error, data ,loading } = useSelector((state) => state.dashboard);
  const { user  } = useSelector((state) => state.users);

  useEffect(() => {
    // dispatch(getFlesData())
    dispatch(getDashboard())

    if(error){
      toast.error(error)
      dispatch(clearError())
    }
  }, []);

 

//     files.forEach((item) => {
//       rows.push({
//         id: item._id,
//         url: item.file.url,
//         user_name: item.userId.name,
//         role: item.userId.role,
//         createAt: item.createdAt,
//       });
//     });

  return (
    <div className="dashboardMain">
      <div className={window.innerWidth>600 ?"menuContainer show" :"menuContainer hide" }>
        <Sidebar underLine={underLine} />
      </div>
      
     {
      loading ? <Loading/> : (
        <div className="dashboardContainer">
        <DashboardHeader heading={"Dasboard"} />
         <MetaData title={'Dashboard'}/>
     
         {
          user && user.role === 'admin' ? (
         
        <div className="D-ButtonLayer">
            <div className="BlRow">
              <div className="BlItem ">
                <div>
                  <p>Total Applications</p>
                  <p>{data?.allApplications}</p>
                </div>
                <div className="BlItem1">
                  <FaUserAlt />
                </div>
              </div>
              <div className="BlItem ">
                <div>
                  <p>Total Applications Approved</p>
                  <p>{data?.TotalApplicationsApproved}</p>
                </div>
                <div className="BlItem2">
                  <FaUserAlt />
                </div>
              </div>
              <div className="BlItem ">
                <div>
                  <p>Total Applications Process</p>
                  <p>{data?.TotalApplicationsProcess}</p>
                </div>
                <div className="BlItem3">
                  <FaUserAlt />
                </div>
              </div>
              <div className="BlItem ">
                <div>
                  <p>Total  Applications Asigned</p>
                  <p>{data?.asignedApplications}</p>
                </div>
                <div className="BlItem4">
                  <FaUserAlt />
                </div>
              </div>
            </div>            
        </div>
          ) : ''
}
        <div className="D-ButtonLayer">
        {
          user && user?.role === 'admin' || user?.role === 'superviser' ? (
            <div className="BlRow">
              <div className="BlItem ">
                <div>
                  <p>Total Files Uploaded</p>
                  <p>{data?.TotalFilesUploaded}</p>
                </div>
                <div className="BlItem1">
                  <FaFile />
                </div>
              </div>
              {
          user && user?.role === 'admin' ? (
            <>
              <div className="BlItem ">
                <div>
                  <p>Total User</p>
                  <p>{data?.TotalUser}</p>
                </div>
                <div className="BlItem2">
                  <FaUsers />
                </div>
              </div>
              <div className="BlItem ">
                <div>
                  <p>Total Counsellors</p>
                  <p>{data?.TotalCounsellors}</p>
                </div>
                <div className="BlItem3">
                  <FaUsers />
                </div>
              </div>
              <div className="BlItem ">
                <div>
                  <p>Total USA Counsellors</p>
                  <p>{data?.TotalUSACounsellors}</p>
                </div>
                <div className="BlItem4">
                  <RiGlobalFill />
                </div>
              </div>
              </>
                      ) : ''
                    }
            </div>
            
            ) : ''
}
            
        </div>

        {
          user && user?.role === 'admin' ? (
        <div className="D-ButtonLayer">
            <div className="BlRow">
              <div className="BlItem ">
                <div>
                  <p>Total UK Counsellors</p>
                  <p>{data?.TotalUKCounsellors}</p>
                </div>
                <div className="BlItem1">
                <RiGlobalFill />

                </div>
              </div>
              <div className="BlItem ">
                <div>
                  <p>Total Canada Counsellors</p>
                  <p>{data?.TotalCanadaCounsellors}</p>
                </div>
                <div className="BlItem2">
                <RiGlobalFill />

                </div>
              </div>
              <div className="BlItem ">
                <div>
                  <p>Total Australia Counsellors</p>
                  <p>{data?.TotalAustraliaCounsellors}</p>
                </div>
                <div className="BlItem3">
                <RiGlobalFill />

                </div>
              </div>
              {/* <div className="BlItem ">
                <div>
                  <p>Total USA Counsellors</p>
                  <p>{data?.TotalUSACounsellors}</p>
                </div>
                <div className="BlItem4">
                  <FaUserAlt />
                </div>
              </div> */}
            </div>

            
        </div>
        ) : ''
}
        {
          user && user?.role === 'lead-counsellor'
          ||  user?.role === 'counsellor' ? (
            
        <div className="D-ButtonLayer">
        <div className="BlRow">
          <div className="BlItem ">
            <div>
              <p>Total asigned User Applications</p>
              <p>{data?.asignedbUseryApplications}</p>
            </div>
            <div className="BlItem1">
            <RiGlobalFill />

            </div>
          </div>
          <div className="BlItem ">
            <div>
              <p>Total Applications Approved </p>
              <p>{data?.TotalApplicationsApprovedByUser}</p>
            </div>
            <div className="BlItem2">
            <RiGlobalFill />

            </div>
          </div>
          <div className="BlItem ">
            <div>
              <p>Total Applications Process</p>
              <p>{data?.TotalApplicationsProcessByUser}</p>
            </div>
            <div className="BlItem3">
            <RiGlobalFill />

            </div>
          </div>
          {/* <div className="BlItem ">
            <div>
              <p>Total USA Counsellors</p>
              <p>{data?.TotalUSACounsellors}</p>
            </div>
            <div className="BlItem4">
              <FaUserAlt />
            </div>
          </div> */}
        </div>

        
    </div>
          ):('')
        }
        {/* <div className="usersContainer">

        <DataGrid
              rows={rows}
              columns={columns}
              pageSize={20}
              disableSelectionOnClick
              className="usersTable"
              // autoHeight
              // autoWidth
              rowHeight={65}
              
              
              sx={{
                fontSize:19,
                backgroundColor:'white',
                boxShadow: 2,
                fontFamily:'Roboto',
                color:'black',
                headerColor: 'black',
                padding:0,
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
                
              }}
            />

          
      </div> */}
      </div>
      )
     }


    </div>
  );
};

export default Dashboard;
